import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import {
  GetIncidentEmissionParameterResultsFetchUrl,
  IIncidentEmissionParameterResult,
} from "../../api/Incident/IIncidentEmissionParameterResult";
import { Grid } from "../Grid";
import { IncidentCorrectiveAndPreventativeActionsGridProps } from "./IncidentCorrectiveAndPreventativeActionsGridProps";

const IncidentEmissionParameterResultsGrid = ({
  incidentId,
  licenceProfile,
}: IncidentCorrectiveAndPreventativeActionsGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetIncidentEmissionParameterResultsFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(incidentId);

  const tableColumnsBig: Column<
    Record<string, IIncidentEmissionParameterResult>
  >[] = [
    {
      Header: "Date",
      accessor: "date",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Parameter",
      accessor: "parameter",
      Filter: false,
    },
    {
      Header: "Sample Type",
      accessor: "sampletype",
      Filter: false,
    },
    {
      Header: "Result",
      accessor: "value",
      Filter: false,
    },
    {
      Header: "Emission Limit Value",
      accessor: "elv",
      Filter: false,
    },
  ];

  const tableColumnsSmall: Column<
    Record<string, IIncidentEmissionParameterResult>
  >[] = [
    {
      Header: "Date",
      accessor: "date",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Parameter",
      accessor: "parameter",
      Filter: false,
    },
    {
      Header: "Result",
      accessor: "value",
      Filter: false,
    },
    {
      Header: "Emission Limit Value",
      accessor: "elv",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { IncidentEmissionParameterResultsGrid };
